export enum PREP_LESSONS_THEME {
    GRID = 'grid',
    DEFAULT = 'default',
    DENSE_GRID = 'dense-grid',
}
